import { useFeatureFlags } from "@/contexts/FeatureFlagContext";
import type { FeedbackContentType } from "@/types/feedback";
import { FeedbackControls } from "./FeedbackControls";

interface FeedbackTrayProps {
  cardTestId: string;
  jobId: string;
  contentType: FeedbackContentType;
  promptKey: string;
  children: React.ReactNode;
}

export function FeedbackTray({
  cardTestId,
  jobId,
  contentType,
  promptKey,
  children,
}: FeedbackTrayProps) {
  const { features } = useFeatureFlags();
  if (!features.inAppFeedback) return <>{children}</>;

  return (
    <div>
      <div className="relative z-10">{children}</div>
      <div
        className="-mt-4 pt-8 px-6 pb-4 bg-secondary-100/50 rounded-b-2xl relative z-0"
        data-testid={`${cardTestId}-feedback-tray`}
      >
        <FeedbackControls
          jobId={jobId}
          contentType={contentType}
          promptKey={promptKey}
        />
      </div>
    </div>
  );
}
